export default "__VITE_ASSET__62ef58f3__"